import { Component } from '@angular/core';
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { Subscription } from 'rxjs';
import { appinfo } from './appinfo';
import { GeaMesNavbarModule } from '@gea-mes/navbar';
import { RouterOutlet } from '@angular/router';

declare var gtag_setValue; // Declare function defined in index.html

const APP_TITLE:string = 'HRXHR';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [GeaMesNavbarModule, RouterOutlet]
})
export class AppComponent {
  title:string = APP_TITLE;
  subtitle:string = APP_TITLE;
  version: any;
  trackingid:string;
  userTitle:string;
  userDivision:string;
  logon$: Subscription;

  constructor (
    private geaMesCognito: GeaMesCognitoAuthService
  )
  {
    this.version = appinfo.version;
    console.log("Version: ", this.version)

  }

  ngOnInit(): void {
    gtag_setValue({"appversion": appinfo.version});

    this.logon$ = this.geaMesCognito.sessionEstablished$.subscribe( out => {
      this.trackingid = this.geaMesCognito.getUserAttribute("trackingid");
      this.userTitle = this.geaMesCognito.getUserAttribute("title");
      this.userDivision = this.geaMesCognito.getUserAttribute("division");
      if (this.trackingid != undefined) {
        gtag_setValue({"sub": this.trackingid});
        gtag_setValue({"title": this.userTitle});
        gtag_setValue({"division": this.userDivision});
        if (this.logon$) this.logon$.unsubscribe(); // We've done the work we need to, can unsubscribe
      }       
    });
  }  
}
